@if (showShareBtn) {
  <button class="transparent" hisImage="WEBSHARE" title="{{btnTitle | hisUi}}" (click)="share()"></button>
}
